// import core component
import Link from "next/link";

// import custom component
import RightArrow from "../SVGs/RightArrow";

// import styles
import styles from "./button.module.scss";

// import interfaces
import ButtonProps from "@/interfaces/Button";

// import utils
import {
  handleBackgroundColor,
  handleBorderColor,
  handleTextColor,
} from "@/utils/Button";

export default function Button({
  isVisibleOnMobile = true,
  id,
  path,
  children,
  bg = "none",
  color = "blue",
  border = false,
  icon = true,
  isLink = false,
  isAnPost = false,
  isBlogCategory = false,
  setToggle,
  is3dFlip = true,
  isFrontAbosolute,
  className = "",
  buttonRef,
}: ButtonProps) {
  const href = isAnPost
    ? "/[blog_name]"
    : isBlogCategory
    ? "/blogue/[blog_category]"
    : path;

  function renderAtag() {
    return (
      <a
        id={id}
        ref={buttonRef}
        draggable={false}
        className={`${styles._default} ${handleBackgroundColor(
          bg,
          styles
        )} ${handleTextColor(color, styles)} ${handleBorderColor(
          border,
          styles
        )} ${isLink ? styles._link : ""} ${
          !isVisibleOnMobile ? styles._hidden_on_mobile : ""
        } ${className}`}
        onClick={() => {
          if (setToggle) setToggle(false);
        }}
      >
        {is3dFlip && !isLink ? (
          <span className={styles["flip-button-vertical"]}>
            <span
              className={`${styles["front"]} ${
                isFrontAbosolute ? styles["alternative"] : ""
              }`}
            >
              {children}
            </span>

            <span
              className={`${styles["back"]} ${
                isFrontAbosolute ? styles["alternative"] : ""
              }`}
            >
              Visitez le lien
            </span>
          </span>
        ) : (
          <>{children}</>
        )}
        {icon && (
          <RightArrow
            arrowClassName={styles["arrow-svg"]}
            tailClassName={styles["arrow-tail"]}
          />
        )}
      </a>
    );
  }

  if (isAnPost || isBlogCategory) {
    return (
      <Link href={href} as={path} scroll={true} passHref>
        {renderAtag()}
      </Link>
    );
  }

  return (
    <Link href={path} scroll={true} passHref>
      {renderAtag()}
    </Link>
  );
}
